var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcImgBuildingTree({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10320_225742)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.8666 9.06563H11.7333V31.3323H5.8666V9.06563Z",
    fill: "#D3F8F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7333 0.665625V31.3323L16.1333 31.3323V25.0656H20.5333V31.3323H24.9333V0.665625H11.7333ZM16.6666 21.7323H15.4666V17.4656H16.6666V21.7323ZM16.6666 15.0656H15.4666V10.799H16.6666V15.0656ZM16.6666 8.39896H15.4666V4.13229H16.6666V8.39896ZM21.1999 21.7323H19.9999V17.4656H21.1999V21.7323ZM21.1999 15.0656H19.9999V10.799H21.1999V15.0656ZM21.1999 8.39896H19.9999V4.13229H21.1999V8.39896Z",
    fill: "#7CE9DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.93327 23.3323C6.93327 25.599 5.4666 27.3323 3.73327 27.3323C1.99993 27.3323 0.533268 25.599 0.533268 23.3323C0.533268 21.0656 3.73327 19.3323 3.73327 19.3323C3.73327 19.3323 6.93327 21.199 6.93327 23.3323Z",
    fill: "#7CE9DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1999 31.7323H11.3333V0.265625H25.1999V31.7323ZM11.9999 30.9323H24.3999V0.932292H11.9999V30.9323Z",
    fill: "#030712"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9333 31.7323H15.7333V24.799H20.9333V31.7323ZM16.3999 30.9323H20.1333V25.4656H16.3999V30.9323Z",
    fill: "#030712"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 31.7323H5.8666V30.9323H11.3333V9.46563H6.13327V17.4656H5.4666V8.79896H11.9999V31.7323Z",
    fill: "#030712"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.8666 27.4656C1.8666 27.4656 0.266602 25.4656 0.266602 23.0656C0.266602 20.6656 3.4666 18.799 3.59994 18.6656H3.8666C3.99994 18.6656 7.19994 20.5323 7.19994 23.0656C7.19994 25.599 5.59994 27.4656 3.59994 27.4656H3.8666ZM3.8666 19.4656C3.19993 19.8656 1.0666 21.3323 1.0666 23.0656C1.0666 24.799 2.2666 26.6656 3.8666 26.6656C5.4666 26.6656 6.6666 25.0656 6.6666 23.0656C6.6666 21.0656 4.53327 19.8656 3.8666 19.4656Z",
    fill: "#030712"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.13327 23.3323H3.4666V31.3323H4.13327V23.3323Z",
    fill: "#030712"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3333 31.7323H24.5333V14.399H31.7333V29.3323C31.7333 30.6656 30.6666 31.7323 29.3333 31.7323ZM25.1999 31.0656H29.3333C30.2666 31.0656 30.9333 30.2656 30.9333 29.4656V15.199H25.1999V31.0656Z",
    fill: "#030712"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6666 17.4656H15.4666V21.7323H16.6666V17.4656Z",
    fill: "#030712"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6666 10.799H15.4666V15.0656H16.6666V10.799Z",
    fill: "#030712"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6666 4.13229H15.4666V8.39896H16.6666V4.13229Z",
    fill: "#030712"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0666 17.4656H19.8666V21.7323H21.0666V17.4656Z",
    fill: "#030712"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0666 10.799H19.8666V15.0656H21.0666V10.799Z",
    fill: "#030712"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0666 4.13229H19.8666V8.39896H21.0666V4.13229Z",
    fill: "#030712"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1999 31.0656H29.3333C30.2666 31.0656 30.9333 30.2656 30.9333 29.4656V15.199H25.1999V31.0656Z",
    fill: "#D3F8F3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10320_225742"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcImgBuildingTree);
export default __webpack_public_path__ + "static/media/ic-img-building-tree.db604f976e79ee3b5607a63b0bd02f31.svg";
export { ForwardRef as ReactComponent };